var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaFeaturedIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 71",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.899 19.45c0 10.74-8.708 19.449-19.45 19.449C9.708 38.899 1 30.19 1 19.449 1 8.708 9.708 0 20.45 0c10.74 0 19.449 8.708 19.449 19.45",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88 12.616c2.886 0 5.096 2.198 5.096 4.91v31.886H6.256V17.526c0-2.805 1.744-4.91 4.63-4.91H56.88z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88 12.616c2.886 0 5.096 2.198 5.096 4.91v31.886H6.256V17.526c0-2.805 1.744-4.91 4.63-4.91H56.88z",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.182 49.412H1v1.042c0 3.68 2.983 7.368 6.663 7.368H59.52c3.68 0 6.663-3.689 6.663-7.368v-1.042z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.182 49.412H1v1.042c0 3.68 2.983 7.368 6.663 7.368H59.52c3.68 0 6.663-3.689 6.663-7.368v-1.042zM29.386 53.617H40.95M10.462 46.258V16.82H57.77v29.437",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.92 55.66L47.259 42.053v23.066c.013.697.559.939 1.117.397l5.217-5.062 5.043 8.908c.426.694 1.422.845 2.228.338l2.109-1.327c.79-.498 1.103-1.447.706-2.14l-4.856-8.41h6.354c.806-.123 1.355-1.756.745-2.163",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.92 55.66L47.259 42.053v23.066c.013.697.559.939 1.117.397l5.217-5.062 5.043 8.908c.426.694 1.422.845 2.228.338l2.109-1.327c.79-.498 1.103-1.447.706-2.14l-4.856-8.41h6.354c.806-.123 1.355-1.756.745-2.163z",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8E9EA",
    strokeWidth: 2,
    d: "M46.207 36.796v-4.205M43.335 37.081l-1.86-3.223M41.235 39.181l-3.223-1.86M40.95 42.053h-4.205M49.073 37.081l1.861-3.223M41.235 44.928l-3.223 1.861"
  }))));
}
export default SvgEaFeaturedIcon2;